import type { MenuItem } from '../types'

export const defaultMenu: MenuItem[] = [
  {
    id: 'iced-coffee',
    name: 'Iced Coffee',
    description: 'A chilled pick-me-up, served just how we have it today.',
    category: 'amenity',
    priceCents: 500,
    enabled: true,
    icon: 'coffee',
    sortOrder: 10,
    archived: false,
  },
  {
    id: 'iced-chai',
    name: 'Iced Chai',
    description: 'Cool, gently spiced, and salon-day perfect.',
    category: 'amenity',
    priceCents: 0,
    enabled: true,
    icon: 'sparkles',
    sortOrder: 20,
    archived: false,
  },
  {
    id: 'fresh-water',
    name: 'Fresh Water',
    description: 'A fresh glass of still water.',
    category: 'amenity',
    priceCents: 0,
    enabled: true,
    icon: 'droplets',
    sortOrder: 30,
    archived: false,
  },
  {
    id: 'water-refill',
    name: 'Water Refill',
    description: 'A discreet refill when your glass is running low.',
    category: 'amenity',
    priceCents: 0,
    enabled: true,
    icon: 'refresh',
    sortOrder: 40,
    archived: false,
  },
  {
    id: 'complimentary-warm-towel',
    name: 'Complimentary Warm Towel',
    description: 'A simple warm towel for your hands or face, with our compliments.',
    category: 'amenity',
    priceCents: 0,
    enabled: true,
    icon: 'sparkles',
    sortOrder: 45,
    archived: false,
  },
  {
    id: 'quiet-appointment',
    name: 'Quiet Appointment',
    description: 'Less conversation, more time to simply unwind.',
    category: 'comfort',
    priceCents: 0,
    enabled: true,
    icon: 'moon',
    sortOrder: 50,
    archived: false,
  },
  {
    id: 'short-break',
    name: 'Restroom or Short Break',
    description: 'Pause at the next comfortable stopping point.',
    category: 'comfort',
    priceCents: 0,
    enabled: true,
    icon: 'pause',
    sortOrder: 60,
    archived: false,
  },
  {
    id: 'check-on-me',
    name: 'Please Check On Me',
    description: 'A quiet way to ask for a quick check-in.',
    category: 'comfort',
    priceCents: 0,
    enabled: true,
    icon: 'heart',
    sortOrder: 70,
    archived: false,
  },
  {
    id: 'comfort-adjustment',
    name: 'Comfort Adjustment',
    description: 'Temperature, cape, chair, music, or another small change.',
    category: 'comfort',
    priceCents: 0,
    enabled: true,
    icon: 'sliders',
    sortOrder: 80,
    archived: false,
  },
  {
    id: 'something-else',
    name: 'Something Else',
    description: 'Share another small comfort request in the optional note.',
    category: 'comfort',
    priceCents: 0,
    enabled: true,
    icon: 'bell',
    sortOrder: 85,
    archived: false,
  },
  {
    id: 'steaming-towel',
    name: 'Steaming Towel Scalp Treatment',
    description: 'Warm steam and a soothing towel ritual for the scalp.',
    category: 'upgrade',
    priceCents: 2000,
    enabled: true,
    icon: 'cloud',
    sortOrder: 90,
    archived: false,
  },
  {
    id: 'scalp-massage',
    name: 'Tension Relief Scalp Massage',
    description: 'An extended scalp massage focused on easing tension.',
    category: 'upgrade',
    priceCents: 4500,
    enabled: true,
    icon: 'waves',
    sortOrder: 100,
    archived: false,
  },
  {
    id: 'tea-tree',
    name: 'Tea Tree Headache Treatment',
    description: 'A cooling, aromatic scalp ritual with tea tree.',
    category: 'upgrade',
    priceCents: 5000,
    enabled: true,
    icon: 'leaf',
    sortOrder: 110,
    archived: false,
  },
]
